export const FETCH_TASKS_MANAGER_TAB_TASKS_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_FAILURE';

export const FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_FAILURE';

export const FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_FAILURE';

export const FETCH_TASKS_MANAGER_TAB_TASKS_TASK_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_TASK_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_TASK_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_TASK_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_TASK_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_TASK_FAILURE';
export const RESET_TASKS_MANAGER_TAB_TASKS_TASK = 'RESET_TASKS_MANAGER_TAB_TASKS_TASK';

export const FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_FAILURE';
export const FETCH_TASKS_MANAGER_TAB_TASKS_CHANGE_FORM_VALUE = 'FETCH_TASKS_MANAGER_TAB_TASKS_CHANGE_FORM_VALUE'; 

export const FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_FAILURE';

export const FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_FAILURE';

export const SET_FILTER_TASKS_MANAGER_TAB_TASKS = 'SET_FILTER_TASKS_MANAGER_TAB_TASKS';

export const RESET_TASKS_MANAGER_TAB_TASKS = 'RESET_TASKS_MANAGER_TAB_TASKS';

export const FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_INIT = 'FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_INIT';
export const FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_SUCCESS = 'FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_SUCCESS';
export const FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_FAILURE = 'FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_FAILURE';



// WEBPACK FOOTER //
// ./source/client/actions/tasks_manager_tab_tasks/types.js